import React, {useEffect} from 'react';
import {Navigate, useLocation} from 'react-router-dom';

import {PageWrapperContent} from 'presentation/components';
import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useContractStatus} from 'presentation/hooks';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {useOperationalCostStore} from 'presentation/hooks/useOperationalCostPassword/store';
import {useServicePermission} from 'presentation/hooks/useServicePermission';
import {useAccountInformation} from '../hooks';

export function AuthorizationsOdontoWrapper() {
	const {canOpenService, serviceTypeByPath} = useServicePermission();
	const {odontoOnly, healthOdonto, isResponsibleWithoutBenefits} = useAccountInformation();
	const {pathname} = useLocation();
	const isOperationalCostAuthorizated = useOperationalCostStore(
		state => state.isOperationalCostAuthorized,
	);
	const serviceType = serviceTypeByPath(pathname);
	const {isValid} = useContractStatus();

	const {isEnabled: isAuthorizationOdontoFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_623_ODONTO,
	);

	const canAccessAuthorizationsOdontoService =
		isValid &&
		!isResponsibleWithoutBenefits &&
		isAuthorizationOdontoFeatureFlagEnabled &&
		(healthOdonto || odontoOnly);

	useEffect(() => {
		if (!canAccessAuthorizationsOdontoService) return;
		if (!isOperationalCostAuthorizated) {
			canOpenService(serviceType);
		}
	}, [pathname, isOperationalCostAuthorizated]);

	if (!canAccessAuthorizationsOdontoService) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <PageWrapperContent />;
}
